import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { UserMenus } from "../../../(general-header)/header/types";

type HeaderState = {
  userData: UserMenus;
  IsRAFEnabled: boolean;
  isLoading: boolean;
  isUserASubscriber: boolean;
  subscriptionLobbyContent: SubscriptionLobbyContent;
};

const initialState: HeaderState = {
  userData: null,
  IsRAFEnabled: false,
  isLoading: true,
  isUserASubscriber: false,
  subscriptionLobbyContent: null,
};

export const headerSlice = createSlice({
  name: "header",
  initialState,
  reducers: {
    publishUserData: (state, action: PayloadAction<{ userData: UserMenus }>) => {
      state.userData = action.payload.userData;
    },
    setIsRafEnabled: (state, action: PayloadAction<boolean>) => {
      state.IsRAFEnabled = action.payload;
    },
    setHeaderIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setIsUserASubscriber: (state, action: PayloadAction<boolean>) => {
      state.isUserASubscriber = action.payload;
    },
    setSubscriptionLobbyContent: (state, action: PayloadAction<SubscriptionLobbyContent>) => {
      state.subscriptionLobbyContent = action.payload;
    },
  },
});

export const {
  publishUserData,
  setIsRafEnabled,
  setHeaderIsLoading,
  setIsUserASubscriber,
  setSubscriptionLobbyContent,
} = headerSlice.actions;

export default headerSlice.reducer;
